import React, { useState, useContext, useEffect, useRef, useCallback } from "react";
import LoadingSpinnerImage from "./LoadingSpinnerImage.js";
import { useDropzone } from 'react-dropzone';

const Attachments = ({ EntityType, EntityId, users, userRole }) => {

    const [attachments, setAttachments] = useState([]);
    const [isLoadingData, setIsLoadingData] = useState(false);
    const [showDeleteAttachmentPopup, setShowDeleteAttachmentPopup] = useState(false);
    const [deleteFileId, setDeleteFileId] = useState(false);


	const onDrop = useCallback((acceptedFiles) => {

        const formData = new FormData();
        acceptedFiles.forEach(file => formData.append('files', file));

        let requestOptions = {
            method: 'POST',
            body: formData,
        };


        setIsLoadingData(true);

        let attachmentUrl = "/umbraco/api/Attachments/Attachments/?entityType=" + EntityType + "&entityId=" + EntityId;

        fetch(attachmentUrl, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                // Update state with the received data
                if (data) {
                    data.map(item => setAttachments(prev => [item, ...prev]));
                    
                }
            })
            .catch((error) => {
            })
            .finally(() => {
                setIsLoadingData(false);
            });

    }, []);



    useEffect(() => {

        loadAttachments();

    }, []);



    const loadAttachments = () => {
        
        let attachmentsUrl = "/umbraco/api/Attachments/Attachments/?entityType=" + EntityType + "&entityId=" + EntityId;

        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

        setIsLoadingData(true);

        fetch(attachmentsUrl, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                // Update state with the received data
                if (data) {
                    setAttachments(data);
                }
            })
            .catch((error) => {
            })
            .finally(() => {
                setIsLoadingData(false);
            });
    }


    const deleteAttachment = () => {

        let fileId = deleteFileId;
        let attachmentsUrl = "/umbraco/api/Attachments/Attachment/?entityType=" + EntityType + "&entityId=" + EntityId + "&fileId=" + fileId;

        const requestOptions = {
            method: "DELETE",
            headers: { "Content-Type": "application/json" },
        };

        setIsLoadingData(true);

        fetch(attachmentsUrl, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.text();
            })
            .then((data) => {

                // Close popup
                setShowDeleteAttachmentPopup(false);

                // Update state with the received data
                setAttachments(prev => prev.filter(item => item.Id != fileId));
            })
            .catch((error) => {
            })
            .finally(() => {
                setIsLoadingData(false);
            });
    }



    const showDeletePopup = (fileId) => {

        setDeleteFileId(fileId);
        setShowDeleteAttachmentPopup(true);

    }





    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: {
            'image/*': [],
            'application/pdf': [], // PDF
            'application/msword': [], // .doc
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [], // .docx
            'application/vnd.ms-excel': [], // .xls
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [], // .xlsx
            'application/vnd.ms-powerpoint': [], // .ppt
            'application/vnd.openxmlformats-officedocument.presentationml.presentation': [] // .pptx
        },
        multiple: true,
    });

    return (
        <>
            <div style={{marginBottom: "40px"}}>

                {/* FILE LIST */}
                {/* FILE LIST */}

                {isLoadingData ? <>
                    <div style={{width: "100%", textAlign: "center", marginTop: "30px"}}>
                        <LoadingSpinnerImage />
                    </div>
                </> : <>
                    {attachments.length > 0 ? <>
                        <br/>
                        <table className="results-table" style={{ width: "100%" }} >
                            <thead>
                                <tr style={{borderBottom: "1px solid #f0f0f0"}}>
                                    <th style={{width: "65%" }}>Filename</th>
                                    <th style={{width: "15%" }}>Uploaded By</th>
                                    <th style={{width: "15%" }}>Date</th>
                                    <th style={{width: "5%" }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {attachments.map((attachment, index) => (
                                    <tr key={index} style={{borderBottom: "1px solid #f0f0f0"}}>
                                        <td><a target="_blank" href={"/umbraco/api/Attachments/Attachment?entityType=" + EntityType + "&entityId=" + EntityId + "&fileId=" + attachment.Id}>{attachment.FileName}</a></td>
                                        <td><User userId={attachment.UploadedBy} users={users} /></td>
                                        <td>{attachment.UploadedOn}</td>
                                        <td>
                                            {userRole === "Admin" && (
                                                <span onClick={() => showDeletePopup(attachment.Id)} style={{ cursor: "pointer", padding: "0px 6px" }}>
                                                    <i className="far fa-trash-alt"></i>
                                                </span>
                                            )}
                                        </td>  </tr>
                                )) }
                            </tbody>
                        </table>
                    </> : <>
                        <div style={{ width: "100%", textAlign: "center", marginTop: "30px" }}>
                            No attachments yet.
                        </div>
                    </>}
                </>}


                {/* UPLOAD BOX */}
                {/* UPLOAD BOX */}
                {userRole === "Admin" ? (
                    <div style={{ display: "flex", justifyContent: "center", width: "100%", marginTop: "20px" }}>
                        <div
                            {...getRootProps()}
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                padding: "30px 20px",
                                border: "2px dashed",
                                borderColor: isDragActive ? "#3498db" : "rgb(209, 213, 219)",
                                borderRadius: "8px",
                                cursor: "pointer",
                                backgroundColor: isDragActive ? "rgb(243, 244, 246)" : "rgb(249, 250, 251)",
                                transition: "all 0.2s ease",
                                width: "60%"
                            }}
                            onMouseEnter={(e) => {
                                if (!isDragActive) {
                                    e.currentTarget.style.backgroundColor = "rgb(243, 244, 246)";
                                    e.currentTarget.style.borderColor = "#3498db";
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (!isDragActive) {
                                    e.currentTarget.style.backgroundColor = "rgb(249, 250, 251)";
                                    e.currentTarget.style.borderColor = "rgb(209, 213, 219)";
                                }
                            }}
                        >
                            <input {...getInputProps()} />

                            {/* Consistent Upload Icon */}
                            <i
                                className="fas fa-upload"
                                style={{
                                    fontSize: "24px",
                                    color: isDragActive ? "#3498db" : "rgb(156, 163, 175)",
                                    marginBottom: "8px"
                                }}
                            ></i>

                            {/* Consistent Text */}
                            <span style={{ textAlign: "center", fontSize: "14px", color: "rgb(75, 85, 99)" }}>
                                {isDragActive
                                    ? "Drop the files here"
                                    : "Click to select files or drag and drop"}
                            </span>
                        </div>
                    </div>
                ) : null}

            </div>



            {/* DELETE POPUP */}
            {/* DELETE POPUP */}

            {showDeleteAttachmentPopup &&
                <div style={{ position: "fixed", top: "0px", left: "0px", width: "100%", height: "100%", backgroundColor: "#000000aa", zIndex: 10 }}>

                    <div style={{position: "absolute", paddingTop: "10px", borderRadius: "15px", width: "350px", height: "100px", border: "1px solid #343434", backgroundColor: "#fafafa", top: "20%", left: "calc(50% - 175px)", textAlign: "center"}}>

                        Are you sure you want to delete this attachment?

                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-around", marginTop: "25px" }} >
                            <div>
                                <div onClick={() => setShowDeleteAttachmentPopup(false)} className="action-button cancel-button">Cancel</div>
                            </div>
                            <div>
                                {isLoadingData ? <>
                                    <LoadingSpinnerImage />
                                </> : <>
                                    <div onClick={() => deleteAttachment()} className="action-button delete-button">Yes, delete</div>
                                </>}
                            </div>
                        </div>
                    </div>

                </div>
             }



        </>
    );



}


const User = ({ userId, users, size = "" }) => {

    const getUserById = (id) => {
        return users.find((item) => item.Id == id);
    };

    let user = getUserById(userId);

    return (
        <>
            {user ? (
                <div
                    className={
                        "user-initials-circle " +
                        (size == "small" ? "user-initials-circle-small" : "")
                    }
                    style={{ backgroundColor: user?.IsItMe ? "#0176b9" : "#e7e7e7", color: user?.IsItMe ? "white" : "black" }}
                    title={user?.Name}
                >
                    {user?.Initials}
                </div>
            ) : null}
        </>
    );
};


export default Attachments;